import initialState from './initialState';
import { types } from '../actions/publicSurveyActions';

export default function publicSurveysReducer(state = initialState.publicSurveys, action) {
  switch (action.type) {
    case types.GET_PUBLIC_SURVEYS: {
      return { fetching: true };
    }
    case types.GET_PUBLIC_SURVEYS_SUCCESS: {
      const { surveys } = action;
      
      return {
        fetching: false,
        data: surveys,
      };
    }
    case types.GET_PUBLIC_SURVEYS_FAILURE: {
      return { fetching: false, data: [] };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/publicSurveysReducer.js